export function positionPopupCloseButton(content) {
    if (!content?.matches('.order-item-more-info.customer, .order-item-more-info.support-ticket')) return;
    const button = content.querySelector(':scope > .carousel__button.is-close');
    const header = content.querySelector(':scope > .ng-popup__header');
    // Keep Fancybox's native control in the sticky header of these scrollable popups.
    if (button && header) header.append(button);
}
